module.exports = "/fonts/bariol_regular-webfont.woff2?0a23fbd17f37364426a8a087709f200c";